
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import HeaderBox from "@/components/query/dialogs/HeaderBox.vue";
import MessageBox from "@/components/query/dialogs/MessageBox.vue";
import {IDataFieldDeletionReport} from "@/auxillary/datafield.deletion";
import DeletedDataField from "@/components/study/dataFieldDeletion/DeletedDataField.vue";

@Component({
  components: {DeletedDataField, HeaderBox, MessageBox}
})
export default class DataFieldsDeletedDialog extends Vue {
  @Prop({required: true})
  deletedFields!: Array<IDataFieldDeletionReport>;


  @Watch('deletedFields', {immediate: true})
  async onDeletedFieldsChange(deletedFields: Array<IDataFieldDeletionReport> | null) {
    if (!deletedFields) {
      console.error("error passing deletedFields");
      return;
    }
  }

  @Emit("no")
  no() {

  }

  @Emit("yes")
  yes() {

  }

}
